
import React, { FC } from 'react';
import { FontAwesomeIcon, FontAwesomeIcons } from '../../../constants/fontAwesomeIcons';
import useDispatch, { useActionCreator } from '../../../hooks/useDispatch';
import useSelector from '../../../hooks/useSelector';
import * as HelpActions from '../../../actions/helpDrawer';

import './HelpButton.scss';

const HelpButton: FC = () => {

    const isOpen = useSelector(state => state.helpDrawer.isOpen);
    
    const dispatch = useDispatch();
    const toggleHelpDrawer = useActionCreator(HelpActions.ToggleHelpDrawer, dispatch);

    const rippleEffect = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        let ripple = document.createElement("span");
        ripple.classList.add("ripple");
        event.currentTarget.appendChild(ripple);

        setTimeout(() => {
            ripple.remove();
        }, 300);
    };

    const handleOnClickEvent: React.MouseEventHandler<HTMLButtonElement> = (
        event
    ) => {
        rippleEffect(event);
        toggleHelpDrawer(!isOpen)
    };

    return (
        <button
            className="help-button help-button-transition"
            onClick={handleOnClickEvent}
            type="button"
        >
            <FontAwesomeIcon 
                className="help-button-icon"
                icon={FontAwesomeIcons.Duotone.CIRCLEQUESTION} 
                fixedWidth
            /> 
        </button>
    );
}


export default HelpButton;